import { ActiveTablesTypes, PlayerPrivacyStatusesEnum, tableTypesEnum } from 'shared/models/LastWins'

import { ILastWinsStatePersisted } from 'features/lastWins/types'

type ReturnMigrationType = (state: ILastWinsStatePersisted) => ILastWinsStatePersisted

export const lastWinsMigrations: Record<string, ReturnMigrationType> = {
  1: state => ({
    ...state,
    data: {
      ...state.data,
      privacySettings: {
        hideMode: PlayerPrivacyStatusesEnum.none,
        isNickHidden: false,
        activeTables: [],
      },
      currentActiveTable: ActiveTablesTypes.standard,
      // slotsWinsTableType: tableTypesEnum.lastBets,
      slotsWinsPageSize: 10,
      slotsWins: {
        page: 1,
        count: 0,
        wins: [],
      },
    },
  }),
}
